import React , { useEffect, useLayoutEffect, useState } from "react";
import MyRouter from "routers/index";
import config from "config.json";
import useFetch from "hooks/useFetch";
interface User {
  firstname: string;
  lastname: string;
  document: string;
  mail: string;
  id: number;
  phones: Phone[];
  semaphore_status: number;
  observations: string;
}

interface Phone {
  phone_number: string;
  active: boolean;
}

function App() {
  /* useEffect(() => {
    const handleBeforeUnload = (event: BeforeUnloadEvent) => {
      sessionStorage.removeItem('user_token');
      sessionStorage.removeItem('user_login');
    };

    window.addEventListener('beforeunload', handleBeforeUnload);

    return () => {
      window.removeEventListener('beforeunload', handleBeforeUnload);
    };
  }, []); */

  const [tokenValue, setTokenValue] = useState("")

  const { data, error, isLoading, fetchData } = useFetch<User>(
    'GET', `${config.backend_url}/authe/token`,
    {},
    { 'Content-Type': 'application/json', 'SetiaAuthorization': `Bearer ${tokenValue}` }
  );

  
  const verifyToken = async () => {
      await fetchData()
  }

  useEffect(() => {
      if(data){
        sessionStorage.setItem('user_token', "Bearer " + tokenValue);
        sessionStorage.setItem('user_login', "true")
        window.location.href = '/' //ya cargado el token redirigo a la home
      }
  },[data])

  useEffect(() => {
      if(tokenValue !== "" && tokenValue !== null && tokenValue !== undefined){
        verifyToken()
      }
  },[tokenValue])

  useEffect(() => {

    const queryParams = new URLSearchParams(window.location.search);
    const token = queryParams.get('token'); // Obtiene el valor de "id"
    console.log("token recibido: ",token)
    if (token !== undefined && token !== null) {
        setTokenValue(token)
    }
  
  },[])
  
  return (
    <div className="bg-white text-base dark:bg-neutral-900 text-neutral-900 dark:text-neutral-200">
      <MyRouter />
    </div>
  );
}

export default App;
